import React, { useEffect, useState } from "react";
import Button from "../../components/common/ui/Button";
import {
  NumberInput,
  RadioInput,
  TextAreaInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import dndSchema from "../../validation/dndSchema";
import { dndAction, authActions } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../components/common/ui/Loader";
import { StoredProcedures } from "../../_helpers/enumerator";
import formatPhoneNumber from "../../_helpers/formatPhoneNumber";
import { getStoredValue } from "../../_helpers/storagehelper";

function AddOrEditDNDUser() {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    getUserDNDList: userDNDList,
  } = useSelector((x) => x?.dnd || {});
  const { DNDTypeRadio, Status } = useSelector(
    (state) => state.dropdownOptions
  );
  const dndID = location?.state ? location?.state?.DNDID : 0;
  const user = useSelector((x) => x.auth.user);
  const addDNDResponse = useSelector((x) => x?.dnd?.createDNDUser);
  const getDNDInfo = useSelector((x) => x?.dnd?.GetPublicUserDNDInfo);

  const [newDNDUser, setNewDNDUser] = useState({
    publicUserDNDListID: 0,
    InviteThrough: "0",
    ContactNumberOrEmail: "",
    Remarks: "",
    IsActive: 1,
    createdBy: getStoredValue("user")?.ManagementUserID,
  });

  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setsubmit] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    switch (addDNDResponse?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        dispatch(authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: user?.FacilityID,
          ProcedureName: StoredProcedures?.PublicUserDNDCUD,
          UserAction: `Created a New DND User ( Mobile/E-mail - ${newDNDUser?.ContactNumberOrEmail})`,
        }));
        history.navigate("/Admin/DNDUserList");
        dispatch(dndAction?.resetForm());
        showToastNotification(
          newDNDUser?.InviteThrough === "0" || newDNDUser?.InviteThrough === "Mobile"
            ? "Mobile added to the DND list"
            : "Email added to the DND list",
          "success"
        );
        break;

      case 2:
        // Insert Management User Activity Log
        dispatch(authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: user?.FacilityID,
          ProcedureName: StoredProcedures?.PublicUserDNDCUD,
          UserAction: `Updated DND User Details (PublicUserDNDListID - ${newDNDUser?.publicUserDNDListID})`,
        }));
        history.navigate("/Admin/DNDUserList");
        dispatch(dndAction?.resetForm());
        showToastNotification(
          "Mobile/Email updated in the DND list",
          "success"
        );
        break;

      case -1:
        showToastNotification(
          "Something went wrong. Please try again.",
          "error"
        );
        break;

      case -2:
        showToastNotification(
          "The provided Mobile/Email already exists in the DND list.",
          "warning"
        );
        break;

      default:
        break;
    }
  }, [addDNDResponse]);

  useEffect(() => {
    if (dndID > 0) {
      setLoader(true);
      dispatch(dndAction?.GetPublicUserDNDInfo(dndID))
        .then((result) => {
          setNewDNDUser(result?.payload);
          setLoader(false);
        })
        .catch((err) => {
          showToastNotification(err?.message, "error");
          setLoader(false);
        });
    }
  }, [dndID]);

  const handleFormSubmit = (e) => {
    e?.preventDefault();
    setErrorMessage({});
    setsubmit(true);
    const { error } = dndSchema(newDNDUser, newDNDUser.InviteThrough);

    if (error?.details) {
      setsubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e?.message,
        }));
      });
      return;
    }

    // const isDuplicate = userDNDList?.DataList?.some((item)=>item.ContactNumberOrEmail === 
    // newDNDUser.ContactNumberOrEmail && item.PublicUserDNDListID !== dndID)

    // if(isDuplicate) {
    //   showToastNotification("Duplicate entry detected. Add/ Update not allowed.", "error");
    //   setsubmit(false);
    //   return;
    // }
    const inviteMethod = newDNDUser.InviteThrough === "0" || newDNDUser.InviteThrough === "Mobile"
      ? "Mobile"
      : "Email"
    const updatedDNDUser = {
      ...newDNDUser,
      InviteThrough: inviteMethod,
    };
    //dispatch(dndAction?.clearDNDSearch())
    if (dndID > 0) {
      dispatch(dndAction?.UpdateDND(updatedDNDUser));
      setsubmit(false);
      return;
    } else {
      dispatch(dndAction?.createDNDUser(updatedDNDUser));
      setsubmit(false);
    }

  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    const { error } = dndSchema({ ...newDNDUser, [name]: value }, newDNDUser.InviteThrough);

    if (error?.details) {
      const fieldError = error.details.find((err) => err.path.includes(name));
      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "",
      }));
    } else {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleChange = (e) => {
    let { name, value } = e?.target;
    setErrorMessage({});

    if (name === "InviteThrough") {
      setNewDNDUser((prevState) => ({
        ...prevState,
        InviteThrough: value,
        ContactNumberOrEmail: "",
        Remarks: ""
      }));
    } else if (name === "ContactNumberOrEmail") {
      if (newDNDUser.InviteThrough === "0" || newDNDUser.InviteThrough === "Mobile") {
        const mobileRegex = /^[0-9]{0,10}$/;
        // if (mobileRegex.test(value)) {

        value = formatPhoneNumber(value);
        setNewDNDUser((prevState) => ({
          ...prevState,
          ContactNumberOrEmail: value
        }));
        // }
      } else {
        setNewDNDUser((prevState) => ({
          ...prevState,
          [name]: value
        }));
      }
    } else {
      setNewDNDUser((prevState) => ({
        ...prevState,
        [name]: name === "IsActive" ? parseInt(value) : value
      }));
    }
  };


  const handleNavigate = () => {
    history.navigate("DNDUserList");
    dispatch(dndAction?.resetForm());
  };

  const handleReset = () => {
    const resetValue = {
      InviteThrough: dndID > 0 ? getDNDInfo?.InviteThrough : "0",
      ContactNumberOrEmail: dndID > 0 ? getDNDInfo?.ContactNumberOrEmail : "",
      Remarks: dndID > 0 ? getDNDInfo?.Remarks : "",
      IsActive: dndID > 0 ? getDNDInfo?.IsActive : 1,
      createdBy: newDNDUser?.createdBy,
      PublicUserDNDListID: dndID > 0 ? getDNDInfo?.PublicUserDNDListID : 0,
    };
    setNewDNDUser(resetValue);
    setErrorMessage({});
  };

  if (loader) return <CustomLoader />;

  return (
    <>

      <div className="add-edit-dnd">
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            <div className="d-flex  flex-wrap justify-content-between align-items-center flex-wrap mb-3">
              <h3 className="text-color mb-0">
                {dndID > 0 ? "EDIT DND USER" : "ADD DND USER"}
              </h3>
              <div className="d-flex flex-wrap gap-3 align-items-center">
                <Button
                  label="Back"
                  type="button"
                  status="primary"
                  icon={'fa-solid fa-angle-left'}
                  onClick={() => {
                    handleNavigate();
                  }}
                />
              </div>
            </div>

            <form className="w-100" onSubmit={handleFormSubmit}>

              <h4 className="inner-header-bg text-color"> <i className='fa-solid fa-circle-info me-2'></i>DND INFORMATION</h4>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="form-floating mb-3">
                    <RadioInput
                      name="InviteThrough"
                      id="InviteThrough"
                      label="DND Type"
                      required
                      options={DNDTypeRadio}
                      handleChange={(e) => handleChange(e)}
                      selectedValue={dndID > 0 ? newDNDUser?.InviteThrough === 'Mobile' ? '0' : '1' : newDNDUser?.InviteThrough}
                      disabled={dndID > 0 ? true : false}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="form-floating mb-3">
                    <RadioInput
                      name="IsActive"
                      id="IsActive"
                      label="Status"
                      options={Status}
                      handleChange={(e) => handleChange(e)}
                      selectedValue={newDNDUser?.IsActive}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="form-floating mb-3">
                    {(newDNDUser.InviteThrough === '0' || newDNDUser.InviteThrough === 'Mobile') && (
                      <TextInput
                        name="ContactNumberOrEmail"
                        id="ContactNumberOrEmail"
                        label="Enter Mobile"
                        placeholder="(000) 000-0000"
                        handleChange={(e) => handleChange(e)}
                        errorMessage={errorMessage}
                        required
                        value={newDNDUser?.ContactNumberOrEmail}
                        maxLength={14}
                        handleBlur={handleBlur}
                      />
                    )}

                    {(newDNDUser.InviteThrough === '1' || newDNDUser.InviteThrough === 'Email') && (
                      <TextInput
                        name="ContactNumberOrEmail"
                        id="ContactNumberOrEmail"
                        label="Enter E-mail"
                        placeholder="Enter E-mail"
                        handleChange={(e) => handleChange(e)}
                        errorMessage={errorMessage}
                        required
                        value={newDNDUser?.ContactNumberOrEmail}
                        handleBlur={handleBlur}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-floating mb-3">
                    <TextAreaInput
                      name="Remarks"
                      id="Remarks"
                      label="Remarks"
                      placeholder="Enter Remarks"
                      handleChange={(e) => handleChange(e)}
                      value={newDNDUser?.Remarks}
                      errorMessage={errorMessage}
                      maxLength={50}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex flex-wrap justify-content-center gap-3 h-100">
                    <Button
                      label={dndID > 0 ? "Update" : "Save"}
                      status="success"
                      icon={dndID > 0 ? 'fa-solid fa-pen-to-square' : 'fa-solid fa-floppy-disk'}
                      type="submit"
                      disabled={submit}
                    />
                    <Button
                      label="Reset"
                      status="secondary"
                      type="button"
                      icon={'fa-solid fa-rotate-right'}
                      onClick={handleReset}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(AddOrEditDNDUser);
